import React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { withRouter } from 'react-router';
import { colors } from '@omilia/theme';
import Preloader from '@omilia/preloader';

import {
  SButton,
  SIcon,
  SIconText,
  SIconWrapper,
  SModalBody,
  SModalDescription,
  SModalContent,
} from './styled';
import { SModalBodyWrapper } from '../../styled';

interface Props extends RouteComponentProps {
  isLoading: boolean;
}

const CreateProject = ({ isLoading }: Props) => (
  <SModalBodyWrapper>
    {isLoading && <Preloader showBackdrop data-test="preloader" />}
    <SModalContent>
      <SModalDescription level={4}>
        You can choose to create a brand new project from scratch, use one of
        the project templates to get a heads up start, import or inherit a
        project that you want to work with!
      </SModalDescription>
      <SModalBody>
        <SButton data-test="create">
          <Link to="/new/create-project">
            <SIconWrapper>
              <SIcon
                glyph="create-project-thin"
                primaryColor={colors.COLOR_BLUE_600}
                size="48"
              />
              <SIconText level={2}>New Project</SIconText>
            </SIconWrapper>
          </Link>
        </SButton>

        <SButton data-test="import">
          <Link to="/new/import-project">
            <SIconWrapper>
              <SIcon
                glyph="import-project"
                primaryColor={colors.COLOR_BLUE_600}
                size="48"
              />
              <SIconText level={2}>Import Project</SIconText>
            </SIconWrapper>
          </Link>
        </SButton>

        <SButton data-test="clone">
          <Link to="/new/clone-project">
            <SIconWrapper>
              <SIcon
                glyph="clone-project-thin"
                primaryColor={colors.COLOR_BLUE_600}
                size="48"
              />
              <SIconText level={2}>Clone Project</SIconText>
            </SIconWrapper>
          </Link>
        </SButton>
      </SModalBody>
    </SModalContent>
  </SModalBodyWrapper>
);

export default withRouter(CreateProject);
